<template>
  <div class="pc-banner-series">
    <div class="pc-banner-series-header">
      <h2>
        {{ title }} Banner管理
        <span class="banner-position">{{ position }}</span>
      </h2>
      <div class="pc-button-group">
        <el-button v-show="isEditting" class="pc-btn addbtn" @click="add">
          添加
        </el-button>
        <el-button
          @click="isEditting = false"
          v-show="isEditting == true"
          class="pc-btn"
        >
          完成
        </el-button>
        <el-button
          @click="isEditting = true"
          v-show="isEditting == false"
          class="pc-btn"
        >
          管理
        </el-button>
      </div>
    </div>

    <el-dialog
      :title="bannerDetail.title"
      :visible.sync="isUpdateShow"
      width="40%"
    >
      <el-form label-width="80px">
        <p class="hint" v-if="isShowHint">请上传图片</p>
        <el-form-item label="位置">
          <p>{{ position }}</p>
        </el-form-item>
        <el-form-item label="序号">
          <el-input v-model="bannerDetail.order_num"></el-input>
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="bannerDetail.title"></el-input>
        </el-form-item>
        <el-form-item label="h5_link">
          <el-input v-model="bannerDetail.h5_link"></el-input>
        </el-form-item>
        <el-form-item label="介绍">
          <el-input
            v-model="bannerDetail.sub_titles"
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片">
          <div class="image-block">
            <UploadImage
              :img="bannerDetail.image"
              :width="268"
              :height="150"
              @getUploadImage="getUploadImageCover"
              class="form-img"
            ></UploadImage>
          </div>
        </el-form-item>

        <el-form-item label="链接">
          <el-input v-model="bannerDetail.links"></el-input>
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="bannerDetail.status">
            <el-option label="有效" :value="parseInt(1)"></el-option>
            <el-option label="失效" :value="parseInt(0)"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog-footer-button-one"
          @click="isUpdateShow = false"
          >取 消</el-button
        >
        <el-button
          class="dialog-footer-button-second"
          type="primary"
          @click="submitBanner"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <div class="box">
      <div class="images-box">
        <div class="image-list">
          <div class="image-item" v-for="(item, index) in list" :key="index">
            <div class="mask">
              <img :src="item.image" />
              <div class="img-mask" v-if="isEditting">
                <div class="mask-button">
                  <p
                    v-if="isEditting"
                    class="mask-buttons"
                    @click="updateBanner(item)"
                  >
                    修改
                  </p>
                  <p
                    v-if="isEditting"
                    class="mask-buttons"
                    @click="isdelete(item)"
                  >
                    删除
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DeleteHint
      :dialogVisible="isShowDelete"
      @cancel="isShowDelete = false"
      @delete="deleteBanner"
    />
  </div>
</template>

<script>
import UploadImage from "./uploadImage.vue";
import DeleteHint from "../template/DeleteHint";
import {
  getBannerList_Api,
  getBanner_Api,
  addBanner_Api,
  updateBanner_Api,
  deleteBanner_Api,
} from "@/apis/settings.api.js";
export default {
  props: { position: String, title: String },
  components: { UploadImage, DeleteHint },
  data() {
    return {
      isShowHint: false,
      list: [],
      bannerDetail: {
        position: null,
        id: null,
        image: null,
      },
      isEditting: false,
      isUpdateShow: false,
      isShowDelete: false,
    };
  },
  mounted() {
    this.bannerDetail.position = this.position;
    this.getBannerList();
  },
  methods: {
    isdelete(item) {
      this.bannerDetail.id = item.id;
      this.isShowDelete = true;
    },

    deleteBanner() {
      console.log(2);
      deleteBanner_Api({
        banner_id: this.bannerDetail.id,
      }).then((res) => {
        this.getBannerList();
        console.log(res);
      });
      this.isShowDelete = false;
    },
    getUploadImageCover(data) {
      this.$set(this.bannerDetail, "image", data);
    },
    getBannerList() {
      getBannerList_Api({ position: this.position }).then((res) => {
        this.list = res.data;
        console.log(res.data);
      });
    },
    getBanner(item) {
      getBanner_Api(item.id).then((res) => {
        this.bannerDetail = res.data;
        console.log(res);
      });
    },
    add() {
      this.isUpdateShow = !this.isUpdateShow;
      for (let key in this.bannerDetail) {
        this.bannerDetail[key] = null;
      }
    },
    submitBanner() {
      if (!this.bannerDetail.image) {
        this.isShowHint = true;
        setTimeout(() => {
          this.isShowHint = false;
        }, 2000);
        return;
      }
      if (!this.bannerDetail.id) {
        this.bannerDetail.position = this.position;
        addBanner_Api(this.bannerDetail).then((res) => {
          this.bannerDetail.id = res.data.id;
          console.log(res);
          this.isEditting = true;
          this.getBannerList();
          console.log(this.bannerDetail);
          console.log(this.bannerDetail.id);
        });
        this.isUpdateShow = !this.isUpdateShow;
      } else {
        this.bannerDetail.banner_id = this.bannerDetail.id;
        updateBanner_Api(this.bannerDetail).then((res) => {
          this.bannerDetail = res.data;
          this.getBannerList();
          console.log(this.bannerDetail.id);
        });
        this.isUpdateShow = !this.isUpdateShow;
      }
    },
    updateBanner(item) {
      console.log(item);
      this.isUpdateShow = !this.isUpdateShow;
      this.getBanner(item);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-form {
  position: relative;
  .hint {
    position: absolute;
    top: -10px;
    right: 0px;
    color: $deleteIcon;
  }
}
/deep/ .el-form-item {
  margin: 0 20px 13px 0;
}
/deep/ .el-dialog__footer {
  .dialog-footer-button-one {
    @include manage-button;
    background: $test;
    color: $blueBtna;
  }
  .dialog-footer-button-second {
    @include manage-button;
  }
}

.pc-banner-series {
  @include box-model;
  .pc-banner-series-header {
    .banner-position {
      font-size: 12px;
      color: $lightenYellow !important;
    }
    margin-bottom: 40px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #c0c0c0;
    > h2 {
      font-size: 20px;
      padding-bottom: 15px;
      color: $mainTitle;
    }
    .pc-button-group {
      margin-top: -10px;
      .pc-btn {
        @include manage-button;
      }
      .addbtn {
        background: $test;
        color: $blueBtna;
      }
    }
  }
  .box {
    overflow-y: hidden;
    overflow-x: auto;
    display: flex;
    height: 170px;
    .upload-image {
      margin-right: 20px;
    }
    .image-list {
      display: flex;
      .image-item {
        position: relative;
        display: inline-block;
        margin-right: 20px;
        .mask {
          position: relative;
          height: 140px;
          width: fit-content;
          img {
            height: 140px;
          }
          .img-mask {
            position: absolute;
            display: none;

            background: $maskbackground;
            top: 0px;
            height: 100%;
            width: 100%;
            .mask-button {
              width: fit-content;
              display: flex;
              margin: 60px auto;

              p {
                border: 1px $base-color dashed;
                width: 60px;
                height: 20px;
                color: $base-color;
                margin-right: 20px;
                text-align: center;
                line-height: 20px;
                cursor: pointer;
              }
              p:hover {
                background: $base-color;
                color: $timeBtn;
              }
            }
          }
        }
        .mask:hover {
          .img-mask {
            display: block;
          }
        }

        .el-icon-error {
          color: $base-color;
          cursor: pointer;
          position: absolute;
          top: 10px;
          right: 10px;
        }
      }

      .image-item:last-child {
        margin-right: 0px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/componentSet/BannerCarousel.vue